import {BifrostBackendApi} from "../../gateways/BifrostBackendApi";

const PersonServiceProvider = {
	baseUrl: `/person`,
	async createPerson(tenantId, user ) {
		return BifrostBackendApi.post(`${this.baseUrl}?tenantId=${tenantId}`, user);
	},
	async deletePerson(tenantId, userId ) {
		const personQueryParams = {
			tenantId
		};
		return BifrostBackendApi.delete(`${this.baseUrl}/${userId}`, {
			params: personQueryParams
		});
	},
	async updatePerson(tenantId, token, user) {
		return BifrostBackendApi.put(`${this.baseUrl}/${token}`, user,{
			params: { tenantId: tenantId },
			headers: {
				Authorizationidp: token
			}
		});
	},
	async getPersonData(tenantId, personId, token) {
		const personQueryParams = {
			tenantId
		};
		return BifrostBackendApi.get(`${this.baseUrl}/${personId}`, {
			params: personQueryParams,
			headers: {
				Authorizationidp: token
			}
		});
	},
	async verifyPersonExistsByEmail(tenantId, email ) {
		const personQueryParams = {
			tenantId,
			email: encodeURIComponent(email)
		};
		return BifrostBackendApi.get(this.baseUrl, {
			params: personQueryParams
		});
	}
};

export default Object.freeze(PersonServiceProvider);
